// extracted by mini-css-extract-plugin
export default {"container":"CardTourismPoints_container__8Mjm0","background":"CardTourismPoints_background__WA1Ln","content":"CardTourismPoints_content__Ii7fQ"};